import { BoardFloorDto } from '@vatos-pas/common';

interface FloorListItem {
  floor: number;
  rows: FloorListRow[];
}

interface FloorListRow {
  boards: any;
}

export const totalBoardsSum = (floors: any) => {
  let count = 0;
  floors.map((floor: FloorListItem) => {
    return floor.rows.map((row: FloorListRow) => {
      const keys = Object.keys(row.boards);
      return keys.map(key => {
        if (row.boards[key] && row.boards[key].quantity) {
          const string = row.boards[key].quantity.toString();
          count = count + parseInt(string);
        }
      });
    });
  });
  return count;
};

export const isSameBoardsQuantity = (
  boardPurchases: any,
  floors: any,
  boardReceipts: any,
) => {
  if (boardReceipts.length) {
    let sumPurchase = 0;
    boardPurchases.boardPurchaseFloors.map((floor: any) => {
      sumPurchase += floor.quantity;
    });
    let sumReceipt = 0;
    boardReceipts.map((boardReceipt: BoardFloorDto) => {
      sumReceipt += boardReceipt.quantity;
    });
    return sumPurchase === sumReceipt;
  }
  if (boardPurchases.boardPurchaseFloors) {
    const sumFilled: number = totalBoardsSum(floors);
    let sumPurchase = 0;
    boardPurchases.boardPurchaseFloors.map((floor: BoardFloorDto) => {
      sumPurchase += floor.quantity;
    });
    return sumFilled === sumPurchase;
  } else {
    throw new Error('No board purchase floors were found on board purchase');
  }
};
